import axios from "axios"
import { ticketBaseURL } from "../configs/api";


export const getTenantByEmailAddress = (emailAddress: string) => {
    return getFetch(`rdRentalTenants/GetTenantByEmailAddress?emailAddress=${emailAddress}`)
}

export const getTenantByUsername = (userName: string) => {
    return getFetch(`rdRentalTenants/GetTenantByUsername?userName=${userName}`)
}

export const getTenantNameAndIdByUsername = (userName: string) => {
    return getFetch(`rdRentalTenants/GetTenantNameAndIdByUsername?userName=${userName}`)
}

const getFetch = async (url: string, params = {}) => {
    const response = await axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    });
    return response.data;
}